import React, { useContext, useEffect, useState } from 'react';
import { TextField, Select, MenuItem, InputAdornment, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { useLocation, useNavigate } from 'react-router-dom';
import { GlobalContext } from '../../../App';
import { useSelector } from 'react-redux';

function SearchBar() {
  const recordsOptions = useSelector((state) => state.recordsOptions.data);

  const { searchText, setSearchText, selectedFilters, setSelectedFilters } = useContext(TemplateContext);
  const { permission } = useContext(GlobalContext);
  const [isSearchFocused, setIsSearchFocused] = useState(false); // מצב לבדיקת פוקוס על שדה החיפוש
  const navigate = useNavigate();
  const location = useLocation(); // שימוש ב־useLocation

  useEffect(() => {
    if (selectedFilters?.length === 0) {
      setSelectedFilters([0])
    }
   }, [selectedFilters]);
   
  // const recordsOptions = [
  //   { id: 0, permissions: [1,2,3,4,5], label: 'כל הרשומות' },
  //   { id: 1, permissions: [1], label: 'בתי עלמין' },
  //   { id: 2, permissions: [1,2,3,4,5], label: 'גושים' },
  //   { id: 3, permissions: [1,2,3,4,5], label: 'חלקות' },
  //   { id: 4, permissions: [1,2,3,4,5], label: 'קברים' },
  //   { id: 5, permissions: [1,2,3,4,5], label: 'רכישות' },
  //   { id: 6, permissions: [1,2,3,4,5], label: 'קבורות' },
  // ];

  const handleFilterChange = (event) => {
    const value = event.target.value;
    if (value.includes(0)) {
      if (value[value?.length - 1] !== 0) {
        const filteredValues = value.filter(val => val !== 0);
        setSelectedFilters(filteredValues);
      } else {
        setSelectedFilters([0]);
      }
    } else {
      setSelectedFilters(value);
    }
  };

  useEffect(() => {
    // אפס את ערך החיפוש בעת שינוי נתיב
    setSearchText('');
  }, [location.pathname]); // האזנה לשינויים במיקום הראוטר

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <TextField
        variant="outlined"
        placeholder="חיפוש"
        sx={{
          borderRadius: '50px 0 0 50px',
          flex: 2,
          backgroundColor: 'rgba(255, 255, 240, 0.9)',
          height: '50px',
          '& .MuiOutlinedInput-root': {
            borderRadius: '50px 0 0 50px',
            height: '50px',
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        value={isSearchFocused ? searchText : ''} // רק אם יש פוקוס מציגים את הערך של searchText
        onChange={(e) => setSearchText(e.target.value)}
        onFocus={() => {
          console.log('test focus');
          setIsSearchFocused(true); // שינוי המצב כדי לאפשר הצגת הערך
          setSearchText(''); // מרוקן את הערך בעת כניסה לפוקוס     
          if (selectedFilters?.length === 0) {
            setSelectedFilters([0]);
          }
          navigate('/globalSearch');
        }}
        onBlur={() => setIsSearchFocused(false)} // בעת איבוד הפוקוס, החזרה למצב ללא פוקוס
      />
      <Select
        multiple
        variant="outlined"
        value={selectedFilters}
        onChange={handleFilterChange}
        renderValue={(selected) => (
          <Box
            sx={{
              display: 'flex',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              width: '100px',
              maxWidth: '100px',
              overflowX: 'auto',
            }}
          >
            {selected.map((id) => recordsOptions.find(option => option.id === id)?.label).join(', ')}
          </Box>
        )}
        sx={{
          borderRadius: '0 50px 50px 0',
          flex: 1,
          backgroundColor: 'rgba(255, 255, 240, 0.9)',
          height: '50px',
          '& .MuiOutlinedInput-root': {
            borderRadius: '0 50px 50px 0',
            height: '50px',
          },
        }}
      >
        {recordsOptions
        .filter(option => (permission === 0 || option?.permissions?.includes(permission)))
        .map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}

export default SearchBar;
